<template>
  <Portal>
    <Modal :show="show" clickaway class="asset-manager" @close="close">
      <Lead
        :action-label="actionLabel"
        :fields="['!comment']"
        @onSubmit="onSubmit"
        :default-data="defaultData"
        :project="item.id"
        :reference="reference"
      >
        <template #title>{{ title }}</template>
        <template #below>
          <Alert v-if="submitted && feedback" theme="success">{{ feedback }}</Alert>
        </template>
      </Lead>
    </Modal>
  </Portal>
</template>

<script>
import mitt from 'mitt'
import { mapState } from 'vuex'
import { DownloadUrl, Capitalize } from './utils'

import { Portal } from '@linusborg/vue-simple-portal'
import { ModalComponent as Modal } from 'vue-elder-modal'
import { AlertComponent as Alert } from 'vue-elder-alert'
import Lead from '@kvass/lead'

const EventBus = mitt()

export { EventBus }
export default {
  data() {
    return {
      show: false,
      timeout: 4000,
      submitted: false,
      options: null,
    }
  },
  computed: {
    ...mapState('Root', ['item']),
    reference() {
      return {
        onModel: ['Project', 'Residential'].find(v => v === this.$route.name) || 'Project',
        ref:
          this.$route.name === 'Residential'
            ? this.$path('$store.state.Residential.item.id')
            : this.item.id,
      }
    },
    title() {
      if (!this.options) return

      return this.$t(
        'assetManagerTitle' + Capitalize(this.options.type) + Capitalize(this.options.strategy),
      )
    },
    actionLabel() {
      if (!this.options) return

      return this.$t(
        'assetManagerAction' + Capitalize(this.options.type) + Capitalize(this.options.strategy),
      )
    },
    feedback() {
      if (!this.options) return

      if (this.options.strategy !== 'request') return
      return this.$t('assetManagerFeedbackBrochureRequest')
    },
    defaultData() {
      if (!this.options) return

      switch (this.options.strategy) {
        case 'request':
          return { comment: this.$t('assetManagerCommentBrochureRequest') }
        default:
          return {}
      }
    },
  },
  methods: {
    onSubmit() {
      switch (this.options.strategy) {
        case 'request':
          this.submitted = true
          setTimeout(() => {
            this.close()
          }, this.timeout)
          return
        case 'lead':
          return this.download()
      }
    },
    close() {
      this.submitted = false
      this.show = false
      this.options = null
    },
    download() {
      this.$tracker.download(this.options.type)
      DownloadUrl(this.options.asset.url, this.options.asset.name)
      this.close()
    },
    init(options = {}) {
      this.options = options

      switch (this.options.strategy) {
        case 'lead':
        case 'request':
          return (this.show = true)
        default:
          return this.download()
      }
    },
  },
  created() {
    EventBus.on('download', this.init)
  },
  components: {
    Portal,
    Modal,
    Lead,
    Alert,
  },
}
</script>

<style lang="scss">
.asset-manager {
  z-index: 1002;

  .lead {
    background-color: white;
    padding: 2rem;
    border-radius: var(--border-radius);
  }
}
</style>
